"use client";

import Link from "next/link";
import { useLocale } from "@/lib/locale-context";
import type { ComponentProps } from "react";
import { withNavigationSpin } from "@/lib/nav-pending";

export default function LocalizedLink({ href, onNavigate, ...props }: ComponentProps<typeof Link>) {
  const { locale } = useLocale();
  const localizedHref =
    typeof href === "string" && href.startsWith("/")
      ? `/${locale}${href}`
      : href;
  return <Link {...props} href={localizedHref} onNavigate={withNavigationSpin(localizedHref, onNavigate)} />;
}
